import * as clone from 'clone'
import { DomainDto } from '../../dtos/domain'
import { NotificationSource } from '../../enums/notification-source'
import { getDefaultNotificationActions } from '../../_utils/domain'
import { GetNotificationResponse } from '@pushly/models/lib/structs/notifications'
import { parseNotificationResponse } from '../../features/notifications/helpers/notification-helpers'
import { NotificationBuilderSubmitType } from '../notification-builder/enums'
import { NotificationDeliveryType } from '../../enums/notification-delivery-type'
import { NotificationDeliveryWindow } from '../../enums/notification-delivery-window'

/**
 * Returns the api-response-form default value
 * that can be passed to parseNotificationResponse()
 */
function getSystemDefaultFallbackNotificationTemplate(domain: DomainDto): any {
    const defaultActions = getDefaultNotificationActions(domain)

    return {
        channels: {
            default: {
                landing_url: 'https://{{domain_url}}',
                title: 'New Content Available',
                actions: defaultActions,
                override_default_actions: false,
                icon_url: domain.defaultIconUrl,
                is_using_domain_default_icon: true,
                badge_url: domain.defaultBadgeUrl,
                is_using_domain_default_badge: true,
                is_silent: false,
                require_interaction: true,
            },
        },
        autoKeywordDiscovery: false,
        keywords: [],
    }
}

/**
 * Returns a GetNotificationResponse with the existing
 * domain fallback - returns system default if null
 */
export function getDomainFallbackNotification(domain: DomainDto): GetNotificationResponse {
    const template = domain.fallbackNotificationTemplate ?? getSystemDefaultFallbackNotificationTemplate(domain)
    if (
        template?.channels?.default?.override_default_actions === false &&
        (template.channels.default.actions?.length ?? 0) === 0
    ) {
        template.channels.default.actions = getDefaultNotificationActions(domain)
    }

    return parseNotificationResponse({
        template,
        audience: {},
        delivery_spec: {},
    })
}

export function getFallbackDisplayPreviewBuild(
    domain: DomainDto,
    type: NotificationBuilderSubmitType,
    notification: GetNotificationResponse,
): any {
    const template = clone(notification.template)
    // @ts-ignore -- todo: rework with models
    delete template?.channels?.default?.id
    // @ts-ignore -- todo: rework with models
    delete template?.channels?.default?.domain_id

    return {
        source: NotificationSource.PREVIEW,
        template,
        audience:
            type === NotificationBuilderSubmitType.PERSONAL_PREVIEW ? { personalPreview: true } : { teamPreview: true },
        delivery_spec: {
            type: NotificationDeliveryType.IMMEDIATE,
            window: NotificationDeliveryWindow.STANDARD,
            ttl_seconds: domain.defaultNotificationTtlSeconds ?? 7 * 60 * 60 * 24,
            ttl_metric: domain.displayMeta.default_notification_ttl_metric ?? 'days',
        },
        meta: {
            origin_domain_id: domain.id,
            preview_type: type === NotificationBuilderSubmitType.PERSONAL_PREVIEW ? 'personal-preview' : 'team-preview',
        },
    }
}
